export const translations = {
  es: {
    // nav
    "nav.home": "Inicio",
    "nav.artists": "Artistas",
    "nav.agenda": "Programa",
    "nav.programa": "Programa",
    "nav.about": "Recorre la muestra",
    "nav.recorrido": "Recorrido virtual",
    "nav.sobreac": "Sobre Arteconciencia",
    "nav.prensa": "Prensa",
    "nav.visitas": "Visitas Guiadas",
    "nav.menu": "Menú",
    "nav.close": "Cerrar",

    // sample markers (clearly provisional content)
    "sample.tag": "Contenido de muestra",
    "sample.note": "Textos provisionales. El contenido definitivo se añadirá más adelante.",
    "sample.artist": "Nombre del artista",
    "sample.title": "Título de la obra",
    "sample.tecnica": "Técnica — muestra",
    "sample.price": "Precio a consultar",
    "sample.nationality": "Nacionalidad",
    "sample.text": "Texto de muestra. Contenido pendiente de entrega.",

    // home
    "home.phrase": "El placer de vivir",
    "home.hero.lede": "Una exposición de arte contemporáneo que reúne a más de 50 artistas en el Palacio Nacional.",
    "home.hero.sublede": "Una experiencia de Arteconciencia a beneficio de Fundarosa.",
    "home.hero.reservar": "Reservar visita guiada",
    "home.hero.revivir": "Revive el recorrido digital",
    "cierre.eyebrow": "El cierre de LATIR",
    "cierre.title": "La muestra en cifras",
    "cierre.visitors": "Visitantes en visitas guiadas",
    "cierre.visits": "Visitas guiadas realizadas",
    "cierre.artists": "Artistas participantes",
    "cierre.sold": "Obras que encontraron hogar",
    "survey.title": "¿Cómo fue tu visita?",
    "survey.intro": "Gracias por acompañarnos en LATIR — El placer de vivir. Tu valoración nos ayuda a cuidar cada detalle.",
    "survey.thanks": "Gracias por tu valoración.",
    "survey.thanksText": "Tu opinión nos ayuda a seguir creando experiencias con propósito.",
    "survey.comment": "Cuéntanos algo más (opcional)",
    "survey.send": "Enviar comentario",
    "survey.sent": "Comentario enviado",
    "survey.home": "Volver al inicio",
    "survey.notfound": "No encontramos esta reserva o el enlace ya no está disponible.",
    "home.hero.lede.post": "LATIR cerró sus puertas en el Palacio Nacional, pero el recorrido digital sigue abierto: once salas, sus obras y audioguías, para revivir la muestra desde cualquier lugar.",
    "home.hero.explorar": "Recorrido virtual",
    "home.hero.explorar.sub": "Visita LATIR desde cualquier lugar",
    "home.about.eyebrow": "Sobre LATIR",
    "home.intro": "LATIR es una exposición de arte contemporáneo impulsada por Arteconciencia que reúne a más de 50 artistas para transformar el arte en un acto de conciencia, encuentro e impacto. Cada obra invita a detenernos, sentir y recordar el inmenso valor de estar vivos. En beneficio de Fundarosa, organización que acompaña a mujeres en la prevención, detección temprana y tratamiento del cáncer de mama. Cada obra adquirida contribuye directamente a hacer posible esa labor.",
    "home.cta": "Explorar la exposición",
    "home.location": "Palacio Nacional · El Salvador",
    "home.scroll": "Desliza",
    "home.link.sobre": "La muestra",

    // artists
    "artists.title": "Todos los artistas",
    "artists.intro": "Listado de obras de la exposición.",
    "artists.filter.discipline": "Disciplina",
    "artists.filter.all": "Todas",
    "artists.count": "obras",
    "artists.view": "Ver esta obra",
    "artists.empty": "No hay obras que coincidan con tu selección.",
    "artists.clear": "Limpiar",

    // detail
    "detail.back": "Todos los artistas",
    "detail.prev": "Anterior",
    "detail.next": "Siguiente",
    "detail.ficha": "Ficha técnica",
    "detail.tecnica": "Técnica",
    "detail.medidas": "Medidas",
    "detail.year": "Año",
    "detail.price": "Precio",
    "detail.status": "Estado",
    "detail.nationality": "Nacionalidad",
    "detail.inspiracion": "Inspiración de la obra",
    "detail.relation": "¿Cómo se relaciona esta obra con LATIR?",
    "detail.practice": "Práctica artística",
    "detail.enquire": "Consultar esta obra",
    "detail.instagram": "Instagram",

    // consult dialog (design preview — not connected)
    "consult.title": "Consultar esta obra",
    "consult.subtitle": "Déjanos tus datos y te contactaremos.",
    "consult.name": "Nombre",
    "consult.email": "Correo electrónico",
    "consult.message": "Mensaje",
    "consult.placeholder": "Escribe tu mensaje…",
    "consult.send": "Enviar consulta",
    "consult.ok": "Abriendo WhatsApp para enviar tu consulta…",
    "consult.demo": "Se abrirá WhatsApp con tu mensaje listo para enviar.",

    // agenda
    "agenda.tag": "Programación",
    "agenda.title": "Programa",
    "agenda.subtitle": "Una agenda para encontrarnos, crear conciencia y vivir el arte.",
    "agenda.intro": "LATIR extiende la experiencia de la exposición a través de una agenda de encuentros privados, actividades abiertas al público, talleres, charlas de concientización y acciones de danza. El programa conecta arte, prevención, comunidad y participación, invitando al público a vivir la muestra desde distintas perspectivas.",
    "agenda.performances": "Performances",
    "agenda.charlas": "Charlas y conversatorios",
    "agenda.charlas.empty": "Programación en construcción.",
    "agenda.talleres": "Talleres",
    "agenda.talleres.empty": "Programación en construcción.",

    // sobre latir
    "sobre.title": "Eje curatorial",
    "sobre.eyebrow": "La muestra",
    "sobre.tesis": "LATIR propone volver la mirada hacia la vida: reconocer su valor, atravesar su fragilidad y convertir el cuidado en una decisión consciente.",
    "sobre.begin": "Comenzar el recorrido",
    "sobre.video.kicker": "Antes de comenzar",
    "sobre.video.text": "Te invitamos a ver este video para acompañar tu recorrido por LATIR.",
    "sobre.video.play": "Reproducir el video del recorrido",
    "sobre.video.aria": "Video del recorrido LATIR — El placer de vivir",
    "sobre.visit.title": "Visita LATIR en el Palacio Nacional.",
    "sobre.visit.cta": "Reservar visita guiada",
    "sobre.index.label": "11 salas · Recorrido completo",
    "sobre.image.pending": "Imagen por asignar",
    "sobre.audio.listen": "Escuchar audioguía",
    "sobre.audio.soon": "Audio próximamente",
    "sobre.audio.transcript": "Leer transcripción",
    "sobre.sala.obras": "Obras en esta sala",
    "sobre.sala.obras.help": "Selecciona una obra para conocerla",
    "sobre.sala.obras.helpMobile": "Toca una obra",
    "sobre.sala.obras.empty": "Selección curatorial por asignar.",
    "sobre.sala.viewwork": "Ver obra",
    "sobre.sala.prev": "Sala anterior",
    "sobre.sala.next": "Sala siguiente",
    "sobre.sala.start": "Inicio",
    "sobre.sala.end": "Fin",
    "sobre.sala.of": "de",
    "sobre.curators": "Ronald Morán y María Elena Padilla, curadores de la muestra.",
    "sobre.resumen": "Más de cincuenta artistas nacionales e internacionales habitan el Palacio Nacional para construir un recorrido alrededor de aquello que nos sostiene y nos transforma: la presencia, los vínculos, la fragilidad, el cuidado y la permanencia.\n\nLATIR nace desde <strong>Arteconciencia</strong> y su compromiso con la prevención y detección temprana del cáncer de mama, a beneficio de Fundarosa. Pero su mirada se abre mucho más allá de la enfermedad: invita a detenernos, reconocer el valor de estar aquí y preguntarnos cómo elegimos cuidar la vida.",
    "sobre.readMore": "Leer eje curatorial completo",
    "sobre.readLess": "Cerrar eje curatorial",
    "sobre.body": "<em>LATIR: El placer de vivir</em> nace de una pregunta esencial: ¿qué significa estar verdaderamente presentes en nuestra propia vida?\n\nMás de cincuenta artistas nacionales e internacionales habitan el Palacio Nacional para construir un recorrido alrededor de aquello que nos sostiene y nos transforma: la presencia, los vínculos, la fragilidad, el cuidado y la permanencia.\n\nA lo largo de la muestra, las obras nos confrontan con el cuerpo, el tiempo, la memoria, los otros y nuestra propia vulnerabilidad. Algunas hablan desde lo íntimo; otras desde lo colectivo. Juntas construyen una experiencia que no busca representar la vida, sino hacernos sentir que estamos vivos.\n\nEn ese recorrido, <em>Centro de gravedad</em> y <em>No estoy sola</em> acercan la experiencia a un territorio especialmente sensible: el cuerpo atravesado por la incertidumbre y la fuerza de una comunidad capaz de sostenernos.\n\nLATIR nace desde <strong>Arteconciencia</strong> y su compromiso con la prevención y detección temprana del cáncer de mama, a beneficio de Fundarosa. Pero su mirada se abre mucho más allá de la enfermedad: nos recuerda que tomar conciencia de la vida también es una forma de cuidarla.\n\nLATIR es una invitación a detenernos, sentir y reconocer el inmenso privilegio de estar aquí.",

    // footer
    "footer.by.prefix": "Una iniciativa de ",
    "footer.by.entity": "ARTECONCIENCIA",
    "footer.support.prefix": "Con el apoyo del ",
    "footer.support.entity": "MINISTERIO DE CULTURA DE EL SALVADOR",
    "footer.venue": "Palacio Nacional · El Salvador",
    "footer.tagline": "El placer de vivir",
    "footer.nav": "Navegación",
    "footer.follow": "Seguir",
    "footer.connect": "Conecta",
    "footer.sponsors": "Aliados",
    "footer.rights": "",
  },

  en: {
    "nav.home": "Home",
    "nav.artists": "Artists",
    "nav.agenda": "Programme",
    "nav.programa": "Programme",
    "nav.about": "Take the tour",
    "nav.recorrido": "Virtual tour",
    "nav.sobreac": "About Arteconciencia",
    "nav.prensa": "Press",
    "nav.visitas": "Guided Visits",
    "nav.menu": "Menu",
    "nav.close": "Close",

    "sample.tag": "Sample content",
    "sample.note": "Provisional text. Final content will be added later.",
    "sample.artist": "Artist name",
    "sample.title": "Work title",
    "sample.tecnica": "Technique — sample",
    "sample.price": "Price on request",
    "sample.nationality": "Nationality",
    "sample.text": "Sample text. Content to be provided.",

    "home.phrase": "The pleasure of living",
    "home.hero.lede": "A contemporary art exhibition bringing together more than 50 artists at the Palacio Nacional.",
    "home.hero.sublede": "An Arteconciencia experience in benefit of Fundarosa.",
    "home.hero.reservar": "Book a guided tour",
    "home.hero.revivir": "Relive the digital tour",
    "cierre.eyebrow": "The closing of LATIR",
    "cierre.title": "The exhibition in numbers",
    "cierre.visitors": "Guided-tour visitors",
    "cierre.visits": "Guided tours held",
    "cierre.artists": "Participating artists",
    "cierre.sold": "Artworks that found a home",
    "survey.title": "How was your visit?",
    "survey.intro": "Thank you for joining us at LATIR — El placer de vivir. Your feedback helps us care for every detail.",
    "survey.thanks": "Thank you for your feedback.",
    "survey.thanksText": "Your opinion helps us keep creating meaningful experiences.",
    "survey.comment": "Tell us anything else (optional)",
    "survey.send": "Send comment",
    "survey.sent": "Comment sent",
    "survey.home": "Back to home",
    "survey.notfound": "We couldn't find this booking or the link is no longer available.",
    "home.hero.lede.post": "LATIR has closed its doors at the Palacio Nacional, but the digital tour remains open: eleven rooms, their artworks and audio guides, to relive the exhibition from anywhere.",
    "home.hero.explorar": "Virtual tour",
    "home.hero.explorar.sub": "Visit LATIR from anywhere",
    "home.about.eyebrow": "About LATIR",
    "home.intro": "LATIR is a contemporary art exhibition driven by Arteconciencia that brings together more than 50 artists to turn art into an act of awareness, encounter and impact. Each work invites us to pause, feel and remember the immense value of being alive. In benefit of Fundarosa, an organization that supports women in the prevention, early detection and treatment of breast cancer. Every work acquired contributes directly to making that mission possible.",
    "home.cta": "Explore the exhibition",
    "home.location": "Palacio Nacional · El Salvador",
    "home.scroll": "Scroll",
    "home.link.sobre": "The show",

    "artists.title": "All artists",
    "artists.intro": "List of works in the exhibition.",
    "artists.filter.discipline": "Discipline",
    "artists.filter.all": "All",
    "artists.count": "works",
    "artists.view": "View this work",
    "artists.empty": "No works match your selection.",
    "artists.clear": "Clear",

    "detail.back": "All artists",
    "detail.prev": "Previous",
    "detail.next": "Next",
    "detail.ficha": "Technical sheet",
    "detail.tecnica": "Technique",
    "detail.medidas": "Dimensions",
    "detail.year": "Year",
    "detail.price": "Price",
    "detail.status": "Status",
    "detail.nationality": "Nationality",
    "detail.inspiracion": "Inspiration",
    "detail.relation": "How does this work relate to LATIR?",
    "detail.practice": "Artistic practice",
    "detail.enquire": "Enquire about this work",
    "detail.instagram": "Instagram",

    "consult.title": "Enquire about this work",
    "consult.subtitle": "Leave your details and we will contact you.",
    "consult.name": "Name",
    "consult.email": "Email",
    "consult.message": "Message",
    "consult.placeholder": "Write your message…",
    "consult.send": "Send enquiry",
    "consult.ok": "Opening WhatsApp to send your enquiry…",
    "consult.demo": "WhatsApp will open with your message ready to send.",

    "agenda.tag": "Programme",
    "agenda.title": "Programme",
    "agenda.subtitle": "An agenda to gather, raise awareness and live art.",
    "agenda.intro": "LATIR extends the exhibition experience through an agenda of private gatherings, activities open to the public, workshops, awareness talks and dance actions. The programme connects art, prevention, community and participation, inviting the public to live the show from different perspectives.",
    "agenda.performances": "Performances",
    "agenda.charlas": "Talks and conversations",
    "agenda.charlas.empty": "Programme in progress.",
    "agenda.talleres": "Workshops",
    "agenda.talleres.empty": "Programme in progress.",

    "sobre.title": "Curatorial focus",
    "sobre.eyebrow": "The exhibition",
    "sobre.tesis": "LATIR proposes turning our gaze back toward life: recognizing its value, moving through its fragility, and transforming care into a conscious choice.",
    "sobre.begin": "Begin the tour",
    "sobre.video.kicker": "Before you begin",
    "sobre.video.text": "We invite you to watch this video to accompany your journey through LATIR.",
    "sobre.video.play": "Play the tour video",
    "sobre.video.aria": "LATIR tour video — El placer de vivir",
    "sobre.visit.title": "Visit LATIR at the Palacio Nacional.",
    "sobre.visit.cta": "Book a guided tour",
    "sobre.index.label": "11 halls · Full tour",
    "sobre.image.pending": "Image pending",
    "sobre.audio.listen": "Listen to audio guide",
    "sobre.audio.soon": "Audio coming soon",
    "sobre.audio.transcript": "Read transcript",
    "sobre.sala.obras": "Works in this room",
    "sobre.sala.obras.help": "Select a work to learn more",
    "sobre.sala.obras.helpMobile": "Tap a work",
    "sobre.sala.obras.empty": "Curatorial selection to be announced.",
    "sobre.sala.viewwork": "View work",
    "sobre.sala.prev": "Previous room",
    "sobre.sala.next": "Next room",
    "sobre.sala.start": "Start",
    "sobre.sala.end": "End",
    "sobre.sala.of": "of",
    "sobre.curators": "Ronald Morán and María Elena Padilla, curators of the exhibition.",
    "sobre.resumen": "More than fifty national and international artists inhabit the Palacio Nacional to build a journey around what sustains and transforms us: presence, bonds, fragility, care and permanence.\n\nLATIR is born from <strong>Arteconciencia</strong> and its commitment to the prevention and early detection of breast cancer, in benefit of Fundarosa. Yet its gaze opens far beyond illness: it invites us to pause, to recognize the value of being here, and to ask how we choose to care for life.",
    "sobre.readMore": "Read the full curatorial statement",
    "sobre.readLess": "Close curatorial statement",
    "sobre.body": "LATIR: The pleasure of living is born from a simple, deeply human question: what does it mean to be alive?\n\nMore than fifty national and international artists inhabit eleven halls of the Palacio Nacional of El Salvador — a journey that invites the visitor to pause, observe and feel. Each space represents an act: to breathe, to listen, to recognize, to transform, to care and to remain.\n\nAt the heart of the exhibition, the installations Centro de Gravedad and No estoy sola open a space for reflection on care and community. From there, art becomes a bridge to speak about prevention and early detection of breast cancer, the mission driven by Fundarosa.\n\nMore than an exhibition, LATIR is an invitation to inhabit the present and to remember that caring for our life is also part of the pleasure of living.",

    "footer.by.prefix": "An initiative by ",
    "footer.by.entity": "ARTECONCIENCIA",
    "footer.support.prefix": "With the support of the ",
    "footer.support.entity": "MINISTRY OF CULTURE OF EL SALVADOR",
    "footer.venue": "Palacio Nacional · El Salvador",
    "footer.tagline": "The pleasure of living",
    "footer.nav": "Navigation",
    "footer.follow": "Follow",
    "footer.connect": "Connect",
    "footer.sponsors": "Allies",
    "footer.rights": "",
  },
};
